import React from "react";
import {Phone} from "@mui/icons-material";
import {green} from "@mui/material/colors";
import {MiniCard} from "./MiniCard";
import {useDashboard} from "../../../../context/DashboardContext";

export const ActiveCallsCard = () => {
  const {responseTime, statuses} = useDashboard();

  const chartData = responseTime?.map(i => ({
    ...i,
    dateCreated: i?.hour,
    duration: i?.countActiveCalls?.toFixed(2)
  }));

  return (
    <MiniCard
      icon={Phone}
      color={green[400]}
      title={statuses?.ACTIVE || 0}
      subtitle={"ACTIVE CALLS"}
      data={chartData}
    />
  );
};
